<template>
  <nav v-if="loading || categories.length" :aria-label="$t('categoryStrip.title')" class="border-b border-slate-100 bg-white">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 overflow-x-auto storefront-strip">
      <div class="flex items-center gap-2 whitespace-nowrap">
        <button
          type="button"
          class="h-9 px-3 rounded-full text-sm font-medium border border-slate-200 bg-slate-50 hover:bg-slate-100 text-slate-700"
          @click="$emit('all-click')"
        >
          {{ $t('categoryStrip.all') }}
        </button>
        <template v-if="loading">
          <span v-for="i in 8" :key="i" class="h-9 w-24 rounded-full bg-slate-100 animate-pulse" />
        </template>
        <template v-else>
          <button
            v-for="cat in categories" :key="cat.id"
            type="button"
            class="h-11 pl-1 pr-4 rounded-full text-sm font-medium border border-transparent bg-white text-slate-700 hover:bg-brand-50 hover:text-brand-700 hover:border-brand-100 inline-flex items-center gap-2"
            @click="$emit('category-click', cat)"
          >
            <span class="h-9 w-9 rounded-full bg-slate-100 overflow-hidden shrink-0 ring-1 ring-slate-200">
              <img v-if="cat.image" :src="cat.image" :alt="cat.nom" class="h-full w-full object-cover" loading="lazy" decoding="async" />
            </span>
            {{ cat.nom }}
          </button>
        </template>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'CategoryStrip',
  emits: ['category-click', 'all-click'],
  props: {
    categories: { type: Array, default: () => [] },
    loading:    { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.storefront-strip::-webkit-scrollbar { height: 0; }
.storefront-strip { scrollbar-width: none; }
</style>
